import { useMemo } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { interpolate, useTranslations } from 'common/language'
import { AlbumGalleryCard } from 'common/widgets/blocks'


SchoolDescription.propTypes = {
  data: PropTypes.object.isRequired,
}

function SchoolDescription({ data, ...props }) {
  const { gettext } = useTranslations()
  const dataObject = useMemo(() => {
    const text = [data.text, data.minPriceDescription].filter(Boolean).join('\n\n')
    return { ...data, heading: interpolate(gettext('Why %s'), [data.heading]), text }
  }, [data])
  return (
    <AlbumGalleryCard {...props} data={dataObject} />
  )
}

export default connect(state => ({
  data: {
    heading: get(state, 'schoolNewServices.data.name', ''),
    heading_level: '2',
    text: get(state, 'schoolNewServices.data.static_content.description', ''),
    images: get(state, 'schoolNewServices.data.static_content.media_images', []).slice(1),
    minPriceDescription: get(state, 'schoolNewServices.data.min_price_description', ''),
  },
}))(SchoolDescription)
